function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React from 'react';
import moment from 'moment';
import { useFormContext } from 'react-hook-form';
import { useSelector } from 'react-redux';
import { Controls, validators } from 'shared/helper/form';
import { T, useTranslate } from 'shared/helper/translate';
var CommonSelect = Controls.CommonSelect,
  Select = Controls.Select,
  Text = Controls.Text,
  TextArea = Controls.TextArea;
var notEmpty = validators.notEmpty;
var styles = {
  wrapper: 'mb-3'
};
export var defaultValues = {
  deliveryTimeline: {},
  type: {},
  id: '',
  specialInstructions: '',
  taxpayerNumber: '',
  title: ''
};
var FapiaoForm = function FapiaoForm(_ref) {
  var fapiaoFormVisible = _ref.fapiaoFormVisible;
  var _useTranslate = useTranslate(),
    t = _useTranslate.t,
    translationExists = _useTranslate.translationExists;
  var methods = useFormContext();
  var _methods$watch = methods.watch(['fapiao']),
    _methods$watch2 = _slicedToArray(_methods$watch, 1),
    fapiao = _methods$watch2[0];
  var fapiaoDeliveryTimelines = useSelector(function (_ref2) {
    var payment = _ref2.payment;
    return payment.fapiaoDeliveryTimelines;
  });
  var fapiaoTypes = useSelector(function (_ref3) {
    var payment = _ref3.payment;
    return payment.fapiaoTypes;
  });
  var userFapiaos = useSelector(function (_ref4) {
    var user = _ref4.user;
    return user ? user.fapiaos : [];
  });
  if (!fapiaoFormVisible) {
    return null;
  }
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "col-12"
  }, /*#__PURE__*/React.createElement("legend", null, /*#__PURE__*/React.createElement(T, {
    source: "Fapiao information"
  }))), translationExists('banner-fapiao') ? /*#__PURE__*/React.createElement("div", {
    className: "col-12"
  }, /*#__PURE__*/React.createElement("div", {
    className: "mb-3"
  }, /*#__PURE__*/React.createElement("div", {
    className: "alert alert-warning"
  }, /*#__PURE__*/React.createElement(T, {
    source: "banner-fapiao"
  })))) : null, userFapiaos.length > 0 ? /*#__PURE__*/React.createElement("div", {
    className: "col-12"
  }, /*#__PURE__*/React.createElement(CommonSelect, {
    isClearable: false,
    className: "previous-fapiao-selector dropdown",
    placeholder: t('Select A Previous Fapiao'),
    value: fapiao ? fapiao.id : null,
    onChange: function onChange(sel) {
      return methods.setValue('fapiao', sel.fapiao);
    },
    options: userFapiaos.map(function (fapiao) {
      var createdDate = moment(fapiao.createdAt);
      var fapiaoType = "".concat(t(fapiao.type.label), " - ");
      return {
        value: fapiao.id,
        label: fapiaoType + t('%(day)s %(monthName)s %(year)s', {
          day: createdDate.format('DD'),
          monthName: t(createdDate.format('MMM')),
          year: createdDate.format('YYYY')
        }),
        fapiao: fapiao
      };
    })
  })) : null, /*#__PURE__*/React.createElement("div", {
    className: "col-12"
  }, /*#__PURE__*/React.createElement(Select, {
    label: "Please select the type of Fapiao",
    messages: {
      notEmpty: 'You must select a fapiao type'
    },
    name: "fapiao[type]",
    validators: {
      notEmpty: notEmpty
    },
    styles: styles,
    options: fapiaoTypes.map(function (fapiaoType) {
      return {
        value: fapiaoType.id,
        label: fapiaoType.name
      };
    })
  })), /*#__PURE__*/React.createElement("div", {
    className: "col-12"
  }, /*#__PURE__*/React.createElement(Select, {
    label: "Delivery Timeline",
    messages: {
      notEmpty: 'You must select a fapiao delivery timeline'
    },
    name: "fapiao[deliveryTimeline]",
    validators: {
      notEmpty: notEmpty
    },
    styles: styles,
    options: fapiaoDeliveryTimelines.map(function (timeline) {
      return {
        label: timeline.label,
        value: timeline.value
      };
    }),
    description: "fapiao-delivery-timeline-description"
  })), /*#__PURE__*/React.createElement("div", {
    className: "col-12"
  }, /*#__PURE__*/React.createElement(Text, {
    label: "Fapiao Title",
    messages: {
      notEmpty: 'Fapiao title is required'
    },
    name: "fapiao[title]",
    validators: {
      notEmpty: notEmpty
    },
    styles: styles,
    description: "fapiao-title-description"
  })), /*#__PURE__*/React.createElement("div", {
    className: "col-12"
  }, /*#__PURE__*/React.createElement(Text, {
    label: "Taxpayer number",
    messages: {
      notEmpty: 'Taxpayer number is required.'
    },
    name: "fapiao[taxpayerNumber]",
    validators: {
      notEmpty: notEmpty
    },
    styles: styles,
    description: "fapiao-taxpayer-number-description"
  })), /*#__PURE__*/React.createElement("div", {
    className: "col-12"
  }, /*#__PURE__*/React.createElement(TextArea, {
    label: "Fapiao special instructions",
    name: "fapiao[specialInstructions]",
    styles: styles,
    description: "fapiao-special-instructions-description"
  })))));
};
export default FapiaoForm;